/* globals tempoServerVals */
import Table from 'bam-node-savant-table/table'

import './pitch-tempo-player'

const {
    data,
    params: { is_team_type, splitYears, team },
} = tempoServerVals

// to be abstracted
function toFixed(val, digits) {
    try {
        if (val === null || val === undefined || val === '') {
            return '--'
        }

        return Number(val).toFixed(digits)
    } catch (e) {
        console.log('toFixed error', e, val, digits) // eslint-disable-line no-console
        return val
    }
}

function toPercent(val, digits) {
    try {
        if (val === null || val === undefined || val === '') {
            return '--'
        }

        return `${Number(val * 100).toFixed(digits)}%`
    } catch (e) {
        console.log('toPercent error', e, val, digits) // eslint-disable-line no-console
        return val
    }
}

const secondaryHeaders = [
    {
        name: '',
        colspan: 4,
        headerClass: 'th-name-header',
    },
    {
        name: 'Bases Empty',
        colspan: 5,
        headerClass: 'th-title-header',
    },
    {
        name: 'Runners On Base',
        colspan: 5,
        headerClass: 'th-title-header',
    },
]

// Make it a little safer to reorder
const seasonName = 'Season'
let headers = [
    {
        name: is_team_type ? 'Team' : 'Player',
        field: 'entity_name',
        customSortField: 'entity_name',
        headerClass:
            'th-component-header align-left th-vertical-bottom table-static-column',
        fieldClass: 'tr-data align-left table-static-column',
        photo: is_team_type
            ? undefined
            : '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
        photoId: 'entity_id',
        displayFn: (entity_name, d) =>
            is_team_type
                ? entity_name
                : `<a href="/savant-player/${d.entity_id}">${entity_name}</a>`, // what levels of unsafe is this?
    },
    {
        name: is_team_type ? '' : 'Team',
        field: is_team_type ? 'entity_name' : 'team_name',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        photo: '<img class="table-team-logo" src="{1}" onerror="this.onerror=\'\';this.src=\'https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg\'" />',
        photoId: 'team_image_url',
        photoOnly: true,
    },
    {
        name: seasonName,
        field: 'start_year',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data align-center',
        displayFn: (val, { start_year, end_year }) =>
            start_year === end_year
                ? start_year
                : `${start_year} - ${end_year}`,
    },
    {
        name: 'Pitches',
        field: 'tot_n_empty',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom border-left',
        fieldClass: 'tr-data border-left',
        displayFn: (val) => val || 0,
    },
    {
        name: 'Tempo',
        field: 'median_seconds_empty',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toFixed(val, 1),
    },
    {
        name: 'Timer<br />Equiv.',
        field: 'empty_equiv',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toFixed(val, 1),
    },
    {
        name: 'Fast %',
        field: 'freq_hot_empty',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toPercent(val, 1),
    },
    {
        name: 'Slow %',
        field: 'freq_cold_empty',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toPercent(val, 1),
    },
    {
        name: 'Pitches',
        field: 'tot_n_onbase',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom border-left',
        fieldClass: 'tr-data border-left',
        displayFn: (val) => val || 0,
    },
    {
        name: 'Tempo',
        field: 'median_seconds_onbase',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toFixed(val, 1),
    },
    {
        name: 'Timer<br />Equiv.',
        field: 'onbase_equiv',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toFixed(val, 1),
    },
    {
        name: 'Fast %',
        field: 'freq_hot_onbase',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom',
        fieldClass: 'tr-data',
        displayFn: (val) => toPercent(val, 1),
    },
    {
        name: 'Slow %',
        field: 'freq_cold_onbase',
        type: 'number',
        headerClass: 'th-component-header th-vertical-bottom border-right',
        fieldClass: 'tr-data border-right',
        displayFn: (val) => toPercent(val, 1),
    },
    {
        name: '',
        field: 'entity_id',
        type: 'number',
        headerClass: `th-component-header${is_team_type ? ' hide' : ''}`,
        fieldClass: `tr-data tempo-compare-btn${is_team_type ? ' hide' : ''}`,
        displayFn: (id, d) =>
            `<button 
                data-player-id="${id}" 
                data-year="${d.start_year}" 
                class="btn btn-default compare-btn" 
                style="padding: 2px 8px"
            >
                Compare
            </button>`,
    },
]

if (splitYears !== true) {
    const seasonIdx = headers.findIndex((header) => header.name === seasonName)
    headers = [...headers.slice(0, seasonIdx), ...headers.slice(seasonIdx + 1)]
    // Okay, maybe this is doomed
    secondaryHeaders[0].colspan -= 1
}
const tableDivId = 'pitcher_tempo_table'
if (data && data.length) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders,
        headers,
        data: data.map((d) => ({
            ...d,
            empty_equiv: d.median_seconds_empty
                ? d.median_seconds_empty - 6
                : null,
            onbase_equiv: d.median_seconds_onbase
                ? d.median_seconds_onbase - 6
                : null,
        })),
        uniqueId: 'pitcher_pace_id', // this can't have dashes in it
        defaultSort: tempoServerVals.params.sort.column,
        defaultSortDirection: tempoServerVals.params.sort.direction,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
    })
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location.href = populateUrl()
})

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})

function showWithTeam(value) {
    if (is_team_type) {
        return
    }

    const display = ['', 'split'].includes(value) ? 'none' : 'inline-block'
    document.getElementById('with-team-only-wrapper').style.display = display
}
document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Team'
                : e.target[selectedIndex].text

        if (type === 'Team') {
            showWithTeam(e.target.value)
        }
    })
})

showWithTeam(team || '')

function populateUrl(sortColumn, sortDirection) {
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        n: document.getElementById('ddlMinPitches').value,
        season_end: document.getElementById('ddlSeasonEnd').value,
        season_start: document.getElementById('ddlSeasonStart').value,
        split: document.getElementById('ddlSplitYears').value,
        team: document.getElementById('ddlTeam').value,
        type: document.getElementById('ddlGroup').value,
        with_team_only: document.getElementById('with-team-only').checked
            ? 1
            : 0,
    }

    if (sortColumn) {
        parameters.sortColumn = sortColumn
    }
    if (sortDirection) {
        parameters.sortDirection = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    return `/leaderboard/pitch-tempo?${urlParams.toString()}`
}

let isFixedHeaderShowing = false

window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
        checkHeaderPosition(tableDivId)
    })
})

function checkHeaderPosition(divId) {
    const $el = document.getElementById(divId)
    if (!$el) {
        return
    }
    const { top } = $el.getBoundingClientRect()
    const height = $el.querySelector(`table thead`).offsetHeight
    if (!isFixedHeaderShowing && top < 0) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && top - height > 0) {
        document
            .querySelector(`#${divId} table thead`)
            .classList.remove('fixed-header')
        isFixedHeaderShowing = false
    }
}

/* eslint-disable no-param-reassign */
function addStaticHeader(divId) {
    const width = document.getElementById(divId).offsetWidth

    if (width && width > 767) {
        // Set TH Width before applying fixed-header
        document
            .querySelector('.default-table-row')
            .querySelectorAll('td')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        document
            .querySelector('.tr-component-row')
            .querySelectorAll('th')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        document
            .querySelector(`#${divId} table thead`)
            .classList.add('fixed-header')
    }
}
/* eslint-enable no-param-reassign */
